import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { CardIconTitleDescription, RappiderCardWithIconTitleDescriptionListComponent } from '@rappider/rappider-components';
import { MessageTemplateWithRelations, Page, ProjectModelWithRelations } from '@rappider/rappider-sdk';
import { Subscription } from 'rxjs';

@Component({
  selector: 'rappider-manage-messaging',
  standalone: true,
  imports: [
    CommonModule,
    RappiderCardWithIconTitleDescriptionListComponent
  ],
  templateUrl: './manage-messaging.component.html',
  styleUrls: ['./manage-messaging.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ManageMessagingComponent implements OnInit, OnDestroy {

  subscriptions: Subscription[] = [];

  activeEnvironment: string | undefined = 'DEV';

  messageTemplates: MessageTemplateWithRelations[] = [];

  uiManagementCards?: CardIconTitleDescription[] = [
    {
      id: 'create-message-template',
      title: 'Create New Message Template',
      key: 'create-message-template',
      iconName: 'fa-regular fa-square-plus',
      description: 'Write your message template from scratch with full customization options',
    },
    {
      id: 'create-ai-message-template',
      title: 'Create Message Template with Assistant',
      key: 'create-ai-message-template',
      iconName: 'fa-solid fa-sparkles',
      description: 'Leverage AI to quickly generate a professional message template based on your requirements and specifications',
    }
  ];

  messageTemplateCards?: CardIconTitleDescription[] = [
    {
      id: 'messageTemplateLoading',
      title: 'Message Templates loading...',
      key: 'messageTemplateLoading',
      iconName: 'fa-solid fa-circle-notch fa-spin',
      description: 'Message Templates are loading...',
    }
  ];

  constructor(
    private store: Store<any>,
    private router: Router,
    private cd: ChangeDetectorRef,
  ) { }

  ngOnInit() {
    this.subscribeToData();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  subscribeToData() {
    this.subscriptions = [
      this.subscribeToMessageTemplates()
    ];
  }

  subscribeToMessageTemplates() {
    return this.store.select(state => state.messageTemplate?.data).subscribe(messageTemplates => {
      this.messageTemplates = messageTemplates;
      if (this.messageTemplates) {
        this.mapMessageTemplatesToCards();
      }
    });
  }

  mapMessageTemplatesToCards() {
    this.messageTemplateCards = this.messageTemplates.map(messageTemplate => ({
      id: messageTemplate.id,
      title: messageTemplate.title,
      key: messageTemplate.key,
      iconName: messageTemplate.iconName ?? 'fa-regular fa-envelope',
      description: messageTemplate.description ?? undefined,
    }));

    this.cd.markForCheck();
  }

  onUiManagementCardCardClicked(card: any) {
    console.log('onUiManagementCardCardClicked ', card);
  }

}
